import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { EasmFindingDetailsDataProvider } from '../dataProvider/EasmFindingDetailsDataProvider';

export class EasmFindingDetailsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EasmFindingDetailsDataProvider);
  }
}
